export function getTranslationsPage4(
  newProgram,
  admissionCategoryList,
  localizedStrings,
) {
  newProgram._ses_academicperiodid_value.elementConfig.label =
    localizedStrings.applicationpage.expectedadmitterm;
  newProgram._ses_certificationprogramid_value.elementConfig.label =
    localizedStrings.applicationpage.programofinterest1;
  newProgram._usb_certificationprogramid_value.elementConfig.bottomText =
    localizedStrings.applicationpage.secondProgramChoiceDescription;
  newProgram.usb_admissioncategory.elementConfig.label =
    localizedStrings.applicationpage.admissioncategory;
  const transformAdmissionCategories = (categories, localizedStrings) => {
    const localizedMapping = {
      943240000: localizedStrings.applicationpage.regular,
      943240001: localizedStrings.applicationpage.mature,
      943240002: localizedStrings.applicationpage.auditing,
      943240003: localizedStrings.applicationpage.special,
      943240004: localizedStrings.applicationpage.senior,
      943240005: localizedStrings.applicationpage.visiting,
    };

    return categories.map(({ attributevalue, ...rest }) => ({
      ...rest,
      displayValue: localizedMapping[attributevalue] || rest.displayValue,
      value: attributevalue,
    }));
  };

  const transformedCategories = transformAdmissionCategories(admissionCategoryList, localizedStrings);
  
  // Add "Sélectionner" option at the beginning
  const selectOption = {
    displayValue: "Sélectionner",
    value: "",
  };
  
  newProgram.usb_admissioncategory.elementConfig.options = [selectOption, ...transformedCategories];

  return newProgram;
}

export function getTranslationsPage4AreaofInterest(
  newAreasofInterestPartOne,
  localizedStrings,
) {
  newAreasofInterestPartOne.usb_areasofinterestandservices.elementConfig.options =
    newAreasofInterestPartOne.usb_areasofinterestandservices.elementConfig.options.map(
      (option) => {
        if (option.value === 943240000) {
          return {
            ...option,
            label: localizedStrings.applicationpage.academicadvising,
          };
        } else if (option.value === 943240001) {
          return {
            ...option,
            label:
              localizedStrings.applicationpage.artisticandculturalactivities,
          };
        } else if (option.value === 943240002) {
          return {
            ...option,
            label: localizedStrings.applicationpage.gymlesportex,
          };
        } else if (option.value === 943240003) {
          return {
            ...option,
            label: localizedStrings.applicationpage.intramuralsports,
          };
        } else if (option.value === 943240004) {
          return {
            ...option,
            label:
              localizedStrings.applicationpage.peermentorshipfornewstudents,
          };
        } else if (option.value === 943240005) {
          return {
            ...option,
            label:
              localizedStrings.applicationpage.studentaccessibilityservices,
          };
        } else if (option.value === 943240006) {
          return {
            ...option,
            label:
              localizedStrings.applicationpage.studentgroupsandassociations,
          };
        } else if (option.value === 943240007) {
          return {
            ...option,
            label: localizedStrings.applicationpage.studenthousing,
          };
        } else if (option.value === 943240008) {
          return {
            ...option,
            label: localizedStrings.applicationpage.studentmedia,
          };
        } else if (option.value === 943240009) {
          return {
            ...option,
            label:
              localizedStrings.applicationpage
                .supportforwellbeingandmentalhealth,
          };
        } else if (option.value === 943240010) {
          return {
            ...option,
            label: localizedStrings.applicationpage.competitivesportsteams,
          };
        } else if (option.value === 943240011) {
          return {
            ...option,
            label: localizedStrings.applicationpage.tutoring,
          };
        } else if (option.value === 943240012) {
          return {
            ...option,
            label: localizedStrings.applicationpage.studenttheatretroupe,
          };
        }
        return option;
      },
    );
}
